import { getLocalStorageItem, setLocalStorageItem } from "lib/localStorage";

const MAX_RECENT_STATIONS = 5;
const STORAGE_KEY = "otrl-jp__widget__recent-stations";

export const addRecentStation = ({ station, name, ticketType }) => {
  const storageKey = STORAGE_KEY + `__${name}`;
  const stations = getRecentStations(name, ticketType);

  // Filter out if it's already in the list of recent stations
  let newStations = stations.filter(existingStation => station.nlc !== existingStation.nlc);

  const searchType = {
    ...getRecentStations(name),
    [ticketType]: [{ name: station.name, nlc: station.nlc, csr: station.csr }, ...newStations].slice(
      0,
      MAX_RECENT_STATIONS
    )
  };

  setLocalStorageItem(
    storageKey,
    searchType,
  );
};

export const getRecentStations = (name, ticketType) => {
  const storageKey = STORAGE_KEY + `__${name}`;
  return ticketType ? getLocalStorageItem(storageKey)?.[ticketType] || [] : getLocalStorageItem(storageKey);
};
